import { useWoAttachmentsAuthorizationEnabled } from '../../feature-flags/useWoAttachmentsAuthorizationEnabled';
import { useActor } from '../authorization/useActor';
import type { AttachmentAccess } from './getAttachmentAccess';
import { getEquipmentAttachmentAccess } from './getEquipmentAttachmentAccess';
import type { EquipmentRecord } from './toEquipmentResource';

export const useEquipmentAttachmentAccess = (
  record: EquipmentRecord
): AttachmentAccess =>
  getEquipmentAttachmentAccess({
    actor: useActor(),
    record,
    isEnforced: useWoAttachmentsAuthorizationEnabled(),
  });
